import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;
  padding: 24px 16px;
  border-top: 2px solid ${theme.colors.gray300};
  background-color: ${theme.colors.white};

  position: fixed;
  bottom: 0;

  display: flex;
  align-items: center;
`

export const Input = styled.textarea`
  width: calc(100% - 62px);
  border: none;
  overflow: hidden;
  height: 20px;

  font-size: ${theme.font.sizes.normal};
  color: ${theme.colors.gray900};
  outline: none;

  resize: none;
  box-sizing: border-box;

  &::placeholder {
    color: ${theme.colors.gray400};
  }
`

export const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${theme.colors.green2};

  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    color: ${theme.colors.white};
  }
`
